export default {
    mail: {
        title  : "Email versenden",
        to     : "An",
        cc     : "Kopie",
        subject: "Betreff",
        cancel : "Abbrechen",
        send   : "Email senden",

        templates: {
            label: "Mailvorlagen",
        },

        attachments: {
            label: "Ereignis Dokumente",
            empty: "Keine Dokumente für den Bearbeitungsschritt gefunden.",
            step : "Bearbeitungsschritt"
        },

        maintenance: {
            label: "Wartungsnachweise",
            empty: "Keine Wartungsnachweise für die Anlage gefunden."
        },

        assessment: {
            label: "Prüfberichte",
            empty: "Keine Prüfberichte für die Anlage gefunden."
        },

        incident: {
            notfound: ""
        },

        contact: {
            notfound: "Es wurde kein Kontakt gefunden.",
        },

        message: {
            to: {
                empty: {
                    title  : "<span style='color:red'>Email wurde nicht versendet - Kein Empfänger angegeben</span>",
                    message: "Für die Email wurde kein Empfänger angegeben. Bitte mindestens einen Empfänger für die Email angeben."
                },
                notvalid: {
                    title  : "<span style='color:red'>Email wurde nicht versendet - Adresse in <b>An</b> ungültig</span>",
                    message: "Mindestens eine Email Adresse für einen Empfänger ist nicht gültig. Bitte die <span style='color:red'>rot</span> markierten Email Adressen beim entsprechenden Kontakt korrigieren."
                }
            },

            cc: {
                notvalid: {
                    title  : "<span style='color:red'>Email wurde nicht versendet - Adresse in <b>Kopie</b> ungültig</span>",
                    message: "Mindestens eine Email Adresse für einen Kopie Empfänger ist nicht gültig. Bitte die rot markierten Email Adressen beim entsprechenden Kontakt korrigieren."
                }
            },

            send: {
                failed: {
                    title  : "<span style='color:red'>Email wurde nicht versendet - Mail konnte nicht versendet werden</span>",
                    message: "Die Email konnte in Folge eines technischen Fehlers nicht versendet werden. Falls aktuelle keine Verbundung zum EXCHANGE Server besteht, kann das Senden zu einem späteren Zeitpunkt durchgeführt werden."
                },
                recipients: {
                    title  : "<span style='color:red'>Email wurde nicht versendet - Empänge rungültig</span>",
                    message: "Mindestens ein Empfägner aus der <b>An</b> oder <b>Kopie</b> Liste ist nicht gültig. Bitte die Email Adressen beim jeweiligen Komntakt prüfen und ggf. korrigieren."
                }
            }
        },
    },
}